import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { flagsPlugin } from '../plugin';
import { flagRouteImplRef } from '../routes';

export const FlagCollectionEntryExtension = flagsPlugin.provide(
  createCollectionEntryExtension({
    id: 'flag',
    resourceType: 'Flag',
    routeRef: flagRouteImplRef,
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'FlagsAdminV1Flag',
    render: () => null,
  }),
);
